import { useQuery } from '@tanstack/react-query';
import { getEnergyByPeriod } from '../../../api/nutrition-service';

const useGetEnergyByPeriod = (dateStart, dateEnd) => {
    const {
        data: energyData,
        isLoading: isLoadingEnergy,
        isError: isErrorEnergy,
        error: energyError
    } = useQuery({
        queryKey: ['energy', 'period', dateStart, dateEnd],
        queryFn: () => getEnergyByPeriod(dateStart, dateEnd),
        enabled: !!dateStart && !!dateEnd,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false
    });

    return { energyData, isLoadingEnergy, isErrorEnergy, energyError };
};

export default useGetEnergyByPeriod;
